interface Props {
  [key: string]: any
}

export default function HexWhyButton(props: Props): React.ReactElement {
  const { pathClassName, gradientStart, gradientStop, colorMatrix, id, innerIconOpacity = 1, ...rest } = props
  const FilterId = id ? String(id).replace(/'/g, '') : Math.random().toString(36)

  return (
    <svg
      style={{ WebkitTransform: 'translate3d(0,0,0)' }} // Fix for Safari bug
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      fill="none"
      viewBox="0 0 88 86"
    >
      <g filter={`url(#filter0_${FilterId})`}>
        <path
          d="M40 2C42 1 46 1 49 2L77 17C80 19 82 22 82 26V54C82 58 80 61 77 63L49 78C46 79 42 79 40 78L12 63C8 61 6 58 6 54V26C6 22 8 19 12 17L40 2Z"
          fill={`url(#paint0_${FilterId})`}
          shapeRendering="crispEdges"
        />
      </g>
      <g transform="translate(32, 21) scale(1.2)">
        <path
          d="M9.80659 8.87597e-05C12.7628 8.87597e-05 15.1362 0.810197 16.927 2.43041C18.7462 4.0222 19.6558 6.22513 19.6558 9.03918C19.6558 11.8248 18.7604 13.9567 16.9696 15.4348C15.1789 16.8844 12.8054 17.6093 9.84923 17.6093L9.67868 20.8923H4.4343L4.22111 13.644H6.13979C8.61275 13.644 10.5172 13.3171 11.8532 12.6634C13.1891 12.0096 13.8571 10.8157 13.8571 9.08182C13.8571 7.83113 13.4876 6.83626 12.7486 6.09721C12.0379 5.35817 11.0573 4.98865 9.80659 4.98865C8.49905 4.98865 7.47575 5.34396 6.73671 6.05458C6.02609 6.7652 5.67078 7.74586 5.67078 8.99655H0.0426603C0.0142355 7.26263 0.383758 5.71348 1.15123 4.34909C1.9187 2.9847 3.04148 1.91877 4.51957 1.15129C6.02609 0.383824 7.78843 8.87597e-05 9.80659 8.87597e-05ZM7.03517 31.0826C5.95503 31.0826 5.05964 30.7558 4.34902 30.102C3.66683 29.4198 3.32573 28.5813 3.32573 27.5864C3.32573 26.5915 3.66683 25.7672 4.34902 25.1134C5.05964 24.4312 5.95503 24.0901 7.03517 24.0901C8.08689 24.0901 8.95384 24.4312 9.63604 25.1134C10.3182 25.7672 10.6593 26.5915 10.6593 27.5864C10.6593 28.5813 10.3182 29.4198 9.63604 30.102C8.95384 30.7558 8.08689 31.0826 7.03517 31.0826Z"
          fill="white"
          fillOpacity={innerIconOpacity}
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="83"
          id={`filter0_${FilterId}`}
          width="76"
          x="6"
          y="1"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={colorMatrix} />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_1883_103692" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1883_103692" mode="normal" result="shape" />
        </filter>
        <linearGradient gradientUnits="userSpaceOnUse" id={`paint0_${FilterId}`} x1="54" x2="53" y1="80" y2="0">
          <stop stopColor={gradientStart} />
          <stop offset="1" stopColor={gradientStop} />
        </linearGradient>
      </defs>
    </svg>
  )
}
